export default function Refrigerator(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_570_19061)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.3953 29H7.60465C7.16347 29 6.76402 28.8402 6.47332 28.5809C6.18126 28.3203 6 27.9583 6 27.5583V3.44234C6 3.05518 6.16963 2.70304 6.44596 2.44432C6.73803 2.17084 7.14911 2 7.60465 2H23.3953C23.8796 2 24.314 2.19297 24.6081 2.4984C24.8523 2.75159 25 3.08099 25 3.44234V27.5583C25 27.9848 24.7934 28.3682 24.4665 28.6319C24.1819 28.8605 23.8071 29 23.3953 29Z"
                    stroke="#757575"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9.36621 6.27734V8.21355" stroke="#757575" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.36621 15.6523V19.0944" stroke="#757575" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5.79834 12.0664H25.2593" stroke="#757575" />
            </g>
            <defs>
                <clipPath id="clip0_570_19061">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
